import { buildMastertrackUrlAbsolute } from 'bundles/common/utils/urlUtils';
import { checklistStatusEnum } from 'bundles/premium-certificate/constants/constants';
import type {
  ChecklistStatus,
  EnrollmentChecklistItem,
  EnrollmentChecklistStatuses,
} from 'bundles/premium-certificate/constants/types';

import _t from 'i18n!nls/premium-certificate';

export const checkIsChecklistEnabledForMT = ({
  enrollmentChecklistItems,
}: {
  enrollmentChecklistItems?: Array<EnrollmentChecklistItem | null>;
}) => {
  return !!enrollmentChecklistItems && enrollmentChecklistItems.length > 0;
};

export const checkAreAllChecklistItemsComplete = ({
  enrollmentChecklistItemStatuses = [],
  enrollmentChecklistItems = [],
}: {
  enrollmentChecklistItems?: Array<EnrollmentChecklistItem | null>;
  enrollmentChecklistItemStatuses?: EnrollmentChecklistStatuses;
}) => {
  const completedItemIds = new Set(enrollmentChecklistItemStatuses);
  const allItemIds = enrollmentChecklistItems.map((itm) => itm?.id);
  const itemIdSet = new Set(allItemIds);
  return [...itemIdSet].every((itm) => itm && completedItemIds.has(itm));
};

export const getChecklistStatus = (props: {
  enrollmentChecklistItems?: Array<EnrollmentChecklistItem | null>;
  enrollmentChecklistItemStatuses?: EnrollmentChecklistStatuses;
}) => {
  if (!checkIsChecklistEnabledForMT(props)) {
    return checklistStatusEnum.noChecklistDefined;
  }

  const { enrollmentChecklistItemStatuses } = props;

  if (enrollmentChecklistItemStatuses === undefined) {
    return checklistStatusEnum.checklistNotStartedYet;
  }

  if (checkAreAllChecklistItemsComplete(props)) {
    return checklistStatusEnum.checklistCompleted;
  }

  return checklistStatusEnum.checklistStarted;
};

export const deriveButtonTextFromChecklistStatus = (
  checklistStatus: ChecklistStatus,
  defaultButtonText?: string | null
): string | undefined | null => {
  switch (checklistStatus) {
    case checklistStatusEnum.checklistNotStartedYet:
      return defaultButtonText || _t('Enroll');
    case checklistStatusEnum.checklistStarted:
      return _t('In progress');
    case checklistStatusEnum.checklistCompleted:
      return _t('Go to MasterTrack');
    case checklistStatusEnum.noChecklistDefined:
    default:
      return defaultButtonText;
  }
};

export const deriveEnrollButtonUrl = (enrollmentChecklistStatus: ChecklistStatus, slug: string) => {
  if (enrollmentChecklistStatus === checklistStatusEnum.checklistCompleted) {
    return buildMastertrackUrlAbsolute(slug, 'home');
  }

  return undefined;
};

export const getRegHelpText = (userEmailAddress: string) =>
  userEmailAddress
    ? _t('Use your email #{userEmailAddress}', { userEmailAddress })
    : _t('Use your Coursera email address'); // Fallback, should never happen in production
